//!visibility is available in edit only not in add
import { useEffect, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../../../MainComponents/Hooks/useAxios";
import HelmetTags from "../../../../../MainComponents/HelmetTags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

function AddEditSession({ edit }) {
  const [values, setValues] = useState(null);
  const { courseID, sessionID } = useParams();

  function reducer(state, action) {
    switch (action.type) {
      case "setSubmitAddEditSession": {
        return {
          ...state,
          submitAddEditSession: action.payload,
        };
      }

      default:
        throw Error("Unknown action: " + action.type);
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    submitAddEditSession: {
      flag: "",
      dependency: false,
      data: {},
    },
  });

  let api = edit
    ? process.env.REACT_APP_ADMIN_SESSION_EDIT_SESSION_API
    : process.env.REACT_APP_ADMIN_SESSION_ADD_SESSION_API;
  //!--------- add edit Course -------

  const [SessionAddEditSuccess, SessionAddEditErrors, submitLoading] = useAxios(
    api,
    "POST",
    state.submitAddEditSession.flag,
    state.submitAddEditSession.dependency,
    state.submitAddEditSession.data,
    true
  );

  //!--------- get the Course info for editing -------

  const [SessionInfo, SessionInfoErrors] = useAxios(
    `${process.env.REACT_APP_ADMIN_SESSION_ADD_EDIT_INFO_API}/${sessionID}`,
    "GET",
    sessionID,
    sessionID
  );

  useEffect(() => {
    if (SessionInfo) {
      let temp = SessionInfo.data;
      delete temp.img;
      setValues({ ...temp, visibility: temp.visibility === 1 ? true : false });
    }
  }, [SessionInfo]);

  useEffect(() => {
    //!---add actions ----

    if (SessionAddEditSuccess) {
      navigate(-1);
      reset();
    }
  }, [SessionAddEditSuccess]);

  const navigate = useNavigate();

  const defaultValues = SessionInfo?.data[0];

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "onTouched",
    values: defaultValues,
  });

  const onSubmit = (data) => {
    const finalData = courseID
      ? {
          ...data,
          id: edit ? sessionID : courseID,
          visibility: data.visibility ? 1 : 0,
          description: data?.description || null,
        }
      : {
          ...data,
          id: edit ? sessionID : courseID,
          visibility: data.visibility ? 1 : 0,
          description: data?.description || null,
        };
    dispatch({
      type: "setSubmitAddEditSession",
      payload: {
        flag: "AddEditSession",
        dependency: !state.submitAddEditSession.dependency,
        data: finalData,
      },
    });
  };

  return (
    <section className="flex h-auto w-full flex-col items-center dark:bg-dark dark:text-light">
      <HelmetTags title="Courses | Mr.Mohamed Salama"></HelmetTags>{" "}
      <div className="form-container my-20 flex w-full flex-col items-center">
        <h2 className="my-10 text-center text-2xl font-semibold text-slate-800 dark:text-slate-100">
          {edit ? "Edit Session" : "Add Session"}
        </h2>

        <form
          onSubmit={handleSubmit(onSubmit)}
          encType="multipart/form-data"
          method="post"
          className="admin-quiz-info-form flex w-3/4 alg:w-full flex-col items-stretch gap-6 rounded-2xl p-8 md:p-6 shadow-lg"
        >
          <div className="admin-quiz-info-form__field flex w-full flex-col items-start justify-center gap-2">
            <label htmlFor="name">Name</label>
            <input
              className="admin-quiz-info-form__control"
              type="text"
              id="name"
              placeholder="Name"
              name="name"
              autoComplete="on"
              {...register("name", {
                required: true,
                maxLength: 80,
                minLength: 3,
              })}
            />
            {errors.name && (
              <p className="pt-1 text-xs text-red-500">
                {errors.name.type === "required" && "This field is required."}
                {errors.name.type === "pattern" &&
                  "Only English letters are allowed."}
                {errors.name.type === "maxLength" &&
                  "Allowed Name max length is 80."}
                {errors.name.type === "minLength" &&
                  "Please enter at least 3 letters."}
              </p>
            )}

            {SessionAddEditErrors?.response?.data?.errors?.name && (
              <p className="pt-1 text-xs text-red-500">
                {SessionAddEditErrors?.response?.data?.errors?.name[0]}
              </p>
            )}
          </div>

          <div className="admin-quiz-info-form__field flex w-full flex-col items-start justify-center gap-2">
            <label htmlFor="description">Description</label>
            <textarea
              className="admin-quiz-info-form__control admin-quiz-info-form__textarea resize-none"
              {...register("description", {
                maxLength: 155,
                minLength: 3,
              })}
              name="description"
              id="description"
              cols="40"
              rows="5"
            ></textarea>
            {errors.description && (
              <p className="pt-1 text-xs text-red-500">
                {errors.description.type === "maxLength" &&
                  "Allowed Description Max Length is 155."}
                {errors.description.type === "minLength" &&
                  "Please Enter at Least 3 Letters."}
              </p>
            )}
            {SessionAddEditErrors?.response?.data?.errors?.description && (
              <p className="pt-1 text-xs text-red-500">
                {
                  SessionAddEditErrors?.response?.data?.errors?.description[0]
                }
              </p>
            )}
          </div>

          {edit && (
            <div className="admin-quiz-info-form__toggles flex w-full flex-wrap items-center justify-start gap-8 rounded-xl p-4">
              <div className="admin-quiz-info-form__toggle flex items-center gap-4">
                <label className="visibility-switch">
                  <input
                    id="visibility"
                    name="visibility"
                    {...register("visibility", {
                      required: false,
                    })}
                    type="checkbox"
                  />
                  <span className="visibility-slider">
                    <svg
                      className="slider-icon"
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <path fill="none" d="m4 16.5 8 8 16-16"></path>
                    </svg>
                  </span>
                </label>
                <label
                  className="admin-quiz-info-form__toggle-label cursor-pointer"
                  htmlFor="visibility"
                >
                  Visibility
                </label>
              </div>

              {errors.visibility && (
                <p className="pt-1 text-xs text-red-500">
                  {errors.visibility.type === "required" &&
                    "This field is required."}
                </p>
              )}
              {SessionAddEditErrors?.response?.data?.errors?.visibility && (
                <p className="pt-1 text-xs text-red-500">
                  {
                    SessionAddEditErrors?.response?.data?.errors
                      ?.visibility[0]
                  }
                </p>
              )}
            </div>
          )}

          <button
            disabled={
              !isValid || (submitLoading && state.submitAddEditSession.flag)
            }
            className="admin-quiz-info-form__submit mt-2 w-full"
            type="submit"
          >
            {submitLoading && state.submitAddEditSession.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p>{edit ? "Confirm Editing The Session" : "Add The Session"}</p>
            )}
          </button>
        </form>
      </div>
    </section>
  );
}

export default AddEditSession;
